var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 13.75c.69 0 1.25.56 1.25 1.25v.017a1.25 1.25 0 0 1-2.5 0V15c0-.69.56-1.25 1.25-1.25ZM16.25 20a1.25 1.25 0 1 0-2.5 0v.017a1.25 1.25 0 0 0 2.5 0V20ZM15 23.75c.69 0 1.25.56 1.25 1.25v.017a1.25 1.25 0 0 1-2.5 0V25c0-.69.56-1.25 1.25-1.25ZM16.25 30a1.25 1.25 0 1 0-2.5 0v.017a1.25 1.25 0 0 0 2.5 0V30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.324 3.937c.368.227.593.63.593 1.063v5.998l9.443 6.296c.348.232.557.622.557 1.04V33.75H35a1.25 1.25 0 1 1 0 2.5h-3.3a1.294 1.294 0 0 1-.067 0H5a1.25 1.25 0 1 1 0-2.5h2.083V11.667c0-.474.268-.907.691-1.118l13.334-6.667a1.25 1.25 0 0 1 1.216.055Zm8.093 29.813V19.003l-7.5-5V33.75h7.5Zm-10-22.103V33.75H9.583V12.44l10.834-5.417v4.624Z",
    clipRule: "evenodd"
  })));
};
export default SvgBuilding;